<template>
  <!--Case Study -->
  <div class="landing-case_study">
    <hero-works :props="pageData.elements" :heroHome="false"></hero-works>

    <div class="inside">
      <div class="container-fluid">
        <porfolio :props="pageData.elements"></porfolio>
      </div>
    </div>

    <div class="inside" id="section">
      <div class="container-fluid">
        <div class="case-section case_study-box" v-if="pageData.elements">
          <div
            class="case_study_content inner-content no-gutters"
            v-if="pageData.elements.case_study_description.value !== '<p><br></p>'"
          >
            <div
              v-if="pageData.elements.case_study_description"
              v-html="pageData.elements.case_study_description.value"
            ></div>
          </div>
          <div
            class="case_study_content inner-content case_short_study no-gutters"
            v-else
          >
            <div
              v-if="pageData.elements.case_study_short_description"
              v-html="pageData.elements.case_study_short_description.value"
            ></div>
          </div>

          <div
            class="case_study_aside inner-content no-gutters"
            v-if="pageData.elements.case_study_description.value !== '<p><br></p>'"
          >
            <template v-if="solutions.length">
              <h4>Solutions</h4>
              <ul>
                <li v-for="item in solutions">
                  <a :href="'/solutions/' + item.url.value">{{
                    item.header_title.value.trim()
                  }}</a>
                </li>
              </ul>
            </template>

            <template v-if="pageData.elements.website_url.value.length">
              <h4>Website</h4>
              <a :href="pageData.elements.website_url.value">{{
                pageData.elements.website_url.value
              }}</a>
            </template>

            <template v-if="pageData.elements.awards.value.length >= 12">
              <h4>Awards</h4>
              <div
                class="awards-case-study"
                v-html="pageData.elements.awards.value"
              ></div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <section class="content-works">
      <div class="inside">
        <div class="container-fluid">
          <div class="content-works-title col-md-10 col-md-offset-1 text-center">
            <h2>Related Work</h2>
            <p class="related">{{ relatedText }}</p>
          </div>
        </div>
      </div>
      <boxes-wrapper
        :boxes="relatedWorks"
        :modularContent="modularContent"
        :boxlimit="3"
        :showViewAll="true"
      ></boxes-wrapper>
    </section>
  </div>
</template>

<script>
import apiConnection from "../mixins/apiConnection.js";
import seoModule from "../mixins/seoModule.js";
import hero from "../components/hero.vue";
import boxesWrapperNew from "../components/boxes-wrapper-new.vue";

import porfolio from "../components/porfolio.vue";
import heroWorks from "../components/hero-works.vue";

export default {
  name: "CaseStudy",
  components: {
    hero: hero,
    "boxes-wrapper": boxesWrapperNew,
    porfolio: porfolio,
    "hero-works": heroWorks,
  },
  mixins: [apiConnection, seoModule],
  data() {
    return {
      pageData: [],
      works: [],
      relatedWorks: [],
      solutions: [],
      sliders: [],
      relatedText:
        "At Marcus Thomas, we’re about creating value, not messages; experiences, not just ads. Take a look at some other examples of our work in this area.",
      modularContent: [],
    };
  },
  created() {
    let url = this.$route.path.split("/");
    this.getCaseStudy(url[2]);
    //this.getWorks(4);
    setTimeout(function () {
      var x = $(".VueCarousel-dot-container").width();
      $(".VueCarousel-navigation-prev").css(
        "left",
        "calc(50% - " + (x / 2 + 20) + "px )"
      );
      $(".VueCarousel-navigation-next").css(
        "right",
        "calc(50% - " + (x / 2 + 20) + "px )"
      );

      if ($(".VueCarousel-dot-container").children().length < 2) {
        $(".VueCarousel-navigation").hide();
      } else {
        $(".VueCarousel-navigation").show();
      }
    }, 1500);
  },
  mounted() {
    setTimeout(function () {
      $(".st-sticky-share-buttons").addClass("st-sticky-share-buttons-show");
    }, 1500);
  },
};
</script>



// WEBPACK FOOTER //
// CaseStudy.vue?2872dd73